/** FieldHelp copy for the tour operator's Defaults tab (kept beside the components that
 *  use it, like `features/tags/fieldHelp.ts`). "Learn more" opens story 4.7. */
import type { FieldHelpEntry } from '@/components/FieldHelp';

export const DEFAULTS_HELP = {
  // §A — who gets the default tag categories
  own_tours: {
    title: 'Tours counted',
    body: 'Every tour of this operator that is not deleted and gets these defaults — past and future, fixed-date and template tours alike.',
    story: 'top-defaults',
  },
  licensee_tours: {
    title: 'Licensee tours',
    body: 'This operator is a franchise parent, so its defaults also reach its licensees’ tours — each licensee’s own “All tours use the operator defaults” setting decides which.',
    story: 'top-defaults',
  },

  // §B — trip settings
  use_operator_defaults: {
    title: 'All tours use the operator defaults',
    body: 'On: every tour of this operator gets the default tag categories and the settings applied while a tour uses the defaults. Off: only tours with their own “Use operator defaults” do. Not set: the parent operator’s setting, else off.',
    story: 'top-defaults',
  },
  allow_tour_tag_categories_modification: {
    title: 'Tours may change their own tag categories',
    body: 'Off: the dashboard and the console’s tour editor cannot change a tour’s own tag categories. Not set: the parent operator’s setting, else off.',
    story: 'top-defaults',
  },
  'defaults.location_sharing': {
    title: 'Location sharing',
    body: 'Disabled, Optional (on, not important) or Important — in place of each tour’s own level. Read from this operator’s own settings only: a parent operator’s value does not apply.',
    story: 'top-defaults',
  },
  'defaults.has_group_chat': {
    title: 'Group chat',
    body: 'Whether tours have a group chat, in place of each tour’s own switch. Read from this operator’s own settings only.',
    story: 'top-defaults',
  },
  'defaults.mytrips_display': {
    title: 'Show bookings on My Trips',
    body: 'Stored for the dashboard; the guest app doesn’t apply it yet.',
    story: 'top-defaults',
  },
  show_all_users_to_guides_in_nonbespoke_tours: {
    title: 'Guides see every guest on template tours',
    body: 'On template (not fixed-date) tours, guides who may view guest locations see every guest of the date; off: only the guests they observe. A tour’s own setting wins. Not set: the parent operator’s setting, else on.',
    story: 'top-defaults',
  },
  disable_internal_guides_and_staff_conversations: {
    title: 'Turn off internal (guides & staff) chat for every tour',
    body: 'On: no tour of this operator gets an internal guides & staff chat, and a tour cannot turn it back on. Off or not set: each tour decides with its own “Disable internal chat”. Read from this operator’s own settings only.',
    story: 'top-defaults',
  },
  selfreg_verify: {
    title: 'Self-registration verification',
    body: 'Whether self-registration asks guests to confirm their email or phone. Two keys compete — selfreg_links.verify_* (franchise-resolved) wins over the older selfreg_verify_*; the source names the one in force. Edited in Configuration.',
    story: 'top-defaults',
  },
  default_launch_policy: {
    title: 'Default launch policy',
    body: 'The launch policy a tour of this operator uses when it has none of its own.',
    story: 'top-defaults',
  },
} as const satisfies Record<string, FieldHelpEntry>;
